import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=58f9395c&"
import script from "./FormButton.vue?vue&type=script&lang=ts&"
export * from "./FormButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports